export default __webpack_public_path__ + "static/media/210.2294ef6d.jpg";